// Example: AnExampleOFTheResultOFThisFunction ---> An Example OF The Result OF This Function
export const splitCamelCaseString = (str: string) => {
  return str.replace(/([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g, '$1$4 $2$3$5');
};
